// extracted by mini-css-extract-plugin
module.exports = {"link":"a10a3f92e9--link--1t8n1","without-pointer":"a10a3f92e9--without-pointer--3o3CO"};